var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M15.7986 10H8.16746C7.5589 10 7.25413 10.852 7.68445 11.3502L11.5 15.7683C11.7668 16.0772 12.1993 16.0772 12.466 15.7683L16.2816 11.3502C16.7119 10.852 16.4071 10 15.7986 10Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }